import * as React from 'react';
import { SVGProps } from 'react';

const BulkPayoutIconSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 32 32'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      fill='#9395A1'
      d='M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM29 8h-7l8 7V9a1.001 1.001 0 0 0-1-1ZM29 24a1.001 1.001 0 0 0 1-1v-6l-8 7h7ZM2 9v6l8-7H3a1 1 0 0 0-1 1ZM2 23a1 1 0 0 0 1 1h7l-8-7v6Z'
      opacity={0.2}
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M29 8H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z'
    />
    <path
      stroke='#9395A1'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M16 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 8l8 7M22 24l8-7M10 8l-8 7M10 24l-8-7'
    />
  </svg>
);

export default BulkPayoutIconSidebar;
